import React, { useEffect } from "react";
//icons import
import { AiOutlineMenu, AiOutlineLogout } from "react-icons/ai";
import { FiShoppingCart } from "react-icons/fi";
import { BsChatLeft } from "react-icons/bs";
import { RiNotification3Line } from "react-icons/ri";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoMdPerson } from "react-icons/io";

//esfusion imports
import { TooltipComponent } from "@syncfusion/ej2-react-popups";

//components import
import { Cart, Chat, Notification, UserProfile } from ".";

//context
import { useStateContext } from "../contexts/ContextProvider";

//dummy data
import avatar from "../data/avatar.jpg";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/authentication/authSlice";
import { loadUser } from "../redux/authentication/authAction";

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="buttom"
      onClick={customFunc}
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-light-gray"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </TooltipComponent>
);

const Navbar = () => {
  const {
    activeMenu,
    setActiveMenu,
    isClicked,
    setIsClickedm,
    handleClick,
    screenSize,
    setScreenSize,
    currentColor,
  } = useStateContext();
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    //getting the size of the screen at the start
    const handleResize = () => setScreenSize(window.innerWidth);
    // adding event listener to track changes in the screen size
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 900) setActiveMenu(false);
    else setActiveMenu(true);
  }, [screenSize]);

  useEffect(() => {
    dispatch(loadUser());
  }, []);

  return (
    <div className="flex justify-between p-2 md:mx-6 relative">
      <NavButton
        title="Menu"
        customFunc={() => setActiveMenu((prev) => !prev)}
        color={currentColor}
        icon={<AiOutlineMenu />}
      />
      <div className="flex">
        {isAuthenticated && (
          <NavButton
            title="Logout"
            customFunc={() => {
              dispatch(logout());
              console.log("dispatched logout");
            }}
            color={currentColor}
            icon={<AiOutlineLogout />}
          />
        )}

        {isAuthenticated && (
          <TooltipComponent content="Profile" position="BottomCenter">
            <div
              className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded lg"
              onClick={() => {}}
            >
              <img
                src={require("../data/profile.png")}
                alt="avatar"
                className="rounded-full  w-8 h-8"
              />
              <p>
                <span className="text-gray-400 text-14">Hi,</span>{" "}
                <span className="text-gray-400 font-bold ml-1 text-14">
                  {user?.name}
                </span>
              </p>
              <MdKeyboardArrowDown className="text-gray-400 text-14" />
            </div>
          </TooltipComponent>
        )}
      </div>
    </div>
  );
};

export default Navbar;
